import React from "react";
import { useNavigate } from "react-router-dom";
import { useI18n } from "../context/I18nContext";

export default function Footer() {
  const { t } = useI18n();
  const navigate = useNavigate();

  const links = [
    { key: "footer_legal_mentions", path: "/legal/mentions" },
    { key: "footer_legal_cgu", path: "/legal/cgu" },
    { key: "footer_legal_privacy", path: "/legal/privacy" },
  ];

  return (
    <footer
      data-testid="app-footer"
      className="border-t-2 border-[#0A0A0A] py-6 bg-[#F4F4F0]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
        <p className="text-xs uppercase tracking-widest text-[#4B4B4B]">
          © CORP-FILTER.EXE — ITGUIDE SRL
        </p>
        <nav className="flex flex-wrap items-center gap-x-5 gap-y-2">
          {links.map((l) => (
            <button
              key={l.path}
              data-testid={`footer-link-${l.path.split("/").pop()}`}
              onClick={() => navigate(l.path)}
              className="text-xs font-bold uppercase tracking-widest text-[#0A0A0A] hover:text-[#FF3B30] transition-colors"
            >
              {t(l.key)}
            </button>
          ))}
        </nav>
        <p className="text-xs uppercase tracking-widest text-[#4B4B4B] max-w-md">
          {t("footer_note")}
        </p>
      </div>
    </footer>
  );
}
